<template>
  <div class="sched-app-channel-selector">
    <label :class="channelColorCSS">Select a Network</label>
    <v-select :options="channels" :value="selected" @input="changed" :clearable="false" />
  </div>
</template>

<script>
export default {
  data () {
    return {
      channels: [
        { label: '3ABN Network', value: 'main' },
        { label: '3ABN Proclaim Network', value: 'proc' },
        { label: '3ABN Dare to Dream Network', value: 'dare' },
        { label: '3ABN International Network', value: 'int' },
        { label: '3ABN Canada', value: 'canada' },
        { label: '3ABN Kids Network', value: 'kids' },
        { label: '3ABN Latino Network', value: 'lat' },
        { label: '3ABN Praise Him Music', value: 'praise' },
        { label: '3ABN Radio Network', value: 'radio' }
      ]
    }
  },
  computed: {
    selected () {
      return this.$store.state.currentChannel
    },

    channelColorCSS () {
      return `sched-app-${this.$store.state.channel.value}-color`
    }
  },
  methods: {
    changed (channel) {
      this.$store.dispatch('fetchData', { channel })
    }
  }
}
</script>

<style scoped>
.sched-app-channel-selector {
  margin: 20px 0;
}
.sched-app-channel-selector label {
  font-weight: 700;
}
.sched-app-channel-selector .dropdown {
  min-width: 260px;
}
</style>
